import React, { useState, useEffect } from 'react';
import { 
  getVehicles, createVehicle, updateVehicle, deleteVehicle,
  getVehicleMaintenances, createMaintenance, deleteMaintenance,
  getVehicleWarnings, bulkDeleteVehicles
} from '../services/api';
import Modal from '../components/Modal';
import ConfirmModal from '../components/Confirmmodal';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';
import '../styles/Pages.css';
import { useAuth } from '../context/AuthContext';
import { exportVehiclesToExcel } from '../utils/exportUtils';
import { formatCurrency, formatDate } from '../utils/formatters';




function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMaintenanceModalOpen, setIsMaintenanceModalOpen] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleMaintenances, setVehicleMaintenances] = useState([]);
  const [searchTerm, setSearchTerm] = useState(() => {
    return localStorage.getItem('vehicleSearch') || '';
  });
  const [activeTab, setActiveTab] = useState('list');
  const [warnings, setWarnings] = useState(null);
  const { hasPermission } = useAuth();


  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'danger',
    onConfirm: () => {},
    confirmText: 'Evet',
    loading: false
  });

  // Araç form verisi
  const [formData, setFormData] = useState({
    year: new Date().getFullYear(),
    brand: '',
    model: '',
    plate: '',
    insurance_start: '',
    insurance_end: '',
    insurance_company: '',
    insurance_policy_no: '',
    kasko_start: '',
    kasko_end: '',
    kasko_company: '',
    kasko_policy_no: '',
    inspection_start: '',
    inspection_end: '',
    current_km: '',
    is_active: true,
    notes: ''
  });

  // Bakım form verisi
  const [maintenanceForm, setMaintenanceForm] = useState({
    vehicle_id: '',
    maintenance_date: new Date().toISOString().split('T')[0],
    maintenance_type: 'genel',
    current_km: '',
    next_maintenance_km: '',
    next_maintenance_date: '',
    cost: '',
    description: '',
    performed_by: '',
    notes: ''
  });

  const maintenanceTypes = [
    { value: 'genel', label: 'Genel Bakım' },
    { value: 'yag', label: 'Yağ Değişimi' },
    { value: 'fren', label: 'Fren Bakımı' },
    { value: 'lastik', label: 'Lastik Değişimi' },
    { value: 'motor', label: 'Motor Bakımı' },
    { value: 'klima', label: 'Klima Bakımı' },
    { value: 'akü', label: 'Akü Değişimi' },
    { value: 'filtre', label: 'Filtre Değişimi' },
    { value: 'diger', label: 'Diğer' }
  ];

  useEffect(() => {
    setLoading(true);
    fetchData(1).finally(() => setLoading(false));
  }, []);

  // Arama debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(1);
    }, 600);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Kalıcılık
  useEffect(() => {
    localStorage.setItem('vehicleSearch', searchTerm);
  }, [searchTerm]);

  const fetchData = async (page = 1, size) => {
    try {
      const currentSize = size || pageSize;
      const params = { page, limit: currentSize };
      if (searchTerm) params.search = searchTerm;
      
      const [vehiclesRes, warningsRes] = await Promise.all([
        getVehicles(params),
        getVehicleWarnings().catch(() => ({ data: { warnings: {}, total_warnings: 0 } }))
      ]);
      setVehicles(vehiclesRes.data.items || vehiclesRes.data);
      setTotalCount(vehiclesRes.data.total || 0);
      setTotalPages(vehiclesRes.data.pages || 1);
      setCurrentPage(page);
      setWarnings(warningsRes.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Veri yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const fetchMaintenances = async (vehicleId) => {
    try {
      const res = await getVehicleMaintenances(vehicleId);
      setVehicleMaintenances(res.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bakım kayıtları yüklenemedi');
    }
  };

  
  const addOneYear = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    date.setFullYear(date.getFullYear() + 1);
    return date.toISOString().split('T')[0];
  };

  
  const handleInsuranceStartChange = (e) => {
    const startDate = e.target.value;
    setFormData({
      ...formData,
      insurance_start: startDate,
      insurance_end: addOneYear(startDate)
    });
  };

 
  const handleKaskoStartChange = (e) => {
    const startDate = e.target.value;
    setFormData({
      ...formData,
      kasko_start: startDate,
      kasko_end: addOneYear(startDate)
    });
  };

  
  const handleInspectionStartChange = (e) => {
    const startDate = e.target.value;
    setFormData({
      ...formData,
      inspection_start: startDate,
      inspection_end: addOneYear(startDate)
    });
  };

  const handleOpenModal = (vehicle = null) => {
    if (vehicle) {
      setEditingVehicle(vehicle);
      setFormData({
        year: vehicle.year || new Date().getFullYear(),
        brand: vehicle.brand || '',
        model: vehicle.model || '',
        plate: vehicle.plate || '',
        insurance_start: vehicle.insurance_start || '',
        insurance_end: vehicle.insurance_end || '',
        insurance_company: vehicle.insurance_company || '',
        insurance_policy_no: vehicle.insurance_policy_no || '',
        kasko_start: vehicle.kasko_start || '',
        kasko_end: vehicle.kasko_end || '',
        kasko_company: vehicle.kasko_company || '',
        kasko_policy_no: vehicle.kasko_policy_no || '',
        inspection_start: vehicle.inspection_start || '',
        inspection_end: vehicle.inspection_end || '',
        current_km: vehicle.current_km || '',
        is_active: vehicle.is_active ?? true,
        notes: vehicle.notes || ''
      });
    } else {
      setEditingVehicle(null);
      setFormData({
        year: new Date().getFullYear(),
        brand: '',
        model: '',
        plate: '',
        insurance_start: '',
        insurance_end: '',
        insurance_company: '',
        insurance_policy_no: '',
        kasko_start: '',
        kasko_end: '',
        kasko_company: '',
        kasko_policy_no: '',
        inspection_start: '',
        inspection_end: '',
        current_km: '',
        is_active: true,
        notes: ''
      });
    }
    setIsModalOpen(true);
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(() => {
    const saved = localStorage.getItem('vehiclePageSize');
    return saved ? Number(saved) : 50;
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectMode, setSelectMode] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingVehicle(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading(editingVehicle ? 'Güncelleniyor...' : 'Oluşturuluyor...');
    
    const submitData = {
      ...formData,
      year: parseInt(formData.year),
      plate: formData.plate.toUpperCase(),
      current_km: formData.current_km ? parseInt(formData.current_km) : 0
    };
    
    // Boş tarihleri null yap
    ['insurance_start', 'insurance_end', 'kasko_start', 'kasko_end', 'inspection_start', 'inspection_end'].forEach(field => {
      if (!submitData[field]) submitData[field] = null;
    });
    
    try {
      if (editingVehicle) {
        await updateVehicle(editingVehicle.id, submitData);
        toast.success('Araç güncellendi!', { id: loadingToast });
      } else {
        await createVehicle(submitData);
        toast.success('Araç eklendi!', { id: loadingToast });
      }
      handleCloseModal();
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'İşlem başarısız', { id: loadingToast });
    }
  };
  
  const handleBulkDelete = () => {
    setConfirmModal({
      isOpen: true,
      title: 'Toplu Araç Silme',
      message: `${selectedIds.length} aracı silmek istediğinizden emin misiniz? Tüm bakım kayıtları da silinecektir!`,
      type: 'danger',
      confirmText: `Evet, ${selectedIds.length} Aracı Sil`,
      loading: false,
      onConfirm: handleBulkDeleteConfirm
    });
  };

  const handleBulkDeleteConfirm = async () => {
    setConfirmModal(prev => ({ ...prev, loading: true }));
    try {
      await bulkDeleteVehicles(selectedIds);
      toast.success(`${selectedIds.length} araç silindi`);
      setSelectedIds([]);
      setSelectMode(false);
      setConfirmModal(prev => ({ ...prev, isOpen: false }));
      fetchData(currentPage);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Silme hatası');
      setConfirmModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleDeleteClick = (vehicle) => {
    setConfirmModal({
      isOpen: true,
      title: 'Araç Silme',
      message: `${vehicle.plate} plakalı aracı silmek istediğinizden emin misiniz? Tüm bakım kayıtları da silinecektir!`,
      type: 'danger',
      confirmText: 'Evet, Sil',
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteVehicle(vehicle.id);
          toast.success('Araç silindi!');
          fetchData();
        } catch (error) {
          toast.error('Silme başarısız');
        } finally {
          setConfirmModal(prev => ({ ...prev, isOpen: false, loading: false }));
        }
      }
    });
  };

  const handleExportVehicles = async () => {
    const loadingToast = toast.loading('Veriler hazırlanıyor...');
    try {
      const params = { page: 1, limit: 1000 };
      if (searchTerm) params.search = searchTerm;
      const res = await getVehicles(params);
      exportVehiclesToExcel(res.data.items || res.data);
      toast.success('Excel indirildi!', { id: loadingToast });
    } catch (error) {
      toast.error('İndirme hatası', { id: loadingToast });
    }
  };

  const handleViewMaintenances = (vehicle) => {
    setSelectedVehicle(vehicle);
    setActiveTab('maintenances');
    fetchMaintenances(vehicle.id);
  };

  const handleOpenMaintenanceModal = () => {
    setMaintenanceForm({
      vehicle_id: selectedVehicle?.id || '',
      maintenance_date: new Date().toISOString().split('T')[0],
      maintenance_type: 'genel',
      current_km: selectedVehicle?.current_km || '',
      next_maintenance_km: '',
      next_maintenance_date: '',
      cost: '',
      description: '',
      performed_by: '',
      notes: ''
    });
    setIsMaintenanceModalOpen(true);
  };

  const handleSubmitMaintenance = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    
    const submitData = {
      ...maintenanceForm,
      vehicle_id: selectedVehicle.id,
      current_km: maintenanceForm.current_km ? parseInt(maintenanceForm.current_km) : null,
      next_maintenance_km: maintenanceForm.next_maintenance_km ? parseInt(maintenanceForm.next_maintenance_km) : null,
      cost: maintenanceForm.cost ? parseFloat(maintenanceForm.cost) : 0,
      next_maintenance_date: maintenanceForm.next_maintenance_date || null
    };
    
    try {
      await createMaintenance(submitData);
      toast.success('Bakım kaydı eklendi!', { id: loadingToast });
      setIsMaintenanceModalOpen(false);
      fetchMaintenances(selectedVehicle.id);
      fetchData(); 
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'İşlem başarısız', { id: loadingToast });
    }
  };

  const handleDeleteMaintenance = async (maintenanceId) => {
    if (!window.confirm('Bu bakım kaydını silmek istediğinizden emin misiniz?')) return;
    
    const loadingToast = toast.loading('Siliniyor...');
    try {
      await deleteMaintenance(maintenanceId);
      toast.success('Bakım kaydı silindi!', { id: loadingToast });
      fetchMaintenances(selectedVehicle.id);
    } catch (error) {
      toast.error('Silme başarısız', { id: loadingToast });
    }
  };

  const getMaintenanceTypeLabel = (type) => {
    const found = maintenanceTypes.find(t => t.value === type);
    return found ? found.label : type;
  };

 
  const getWarningBadge = (daysLeft) => {
    if (daysLeft === null || daysLeft === undefined) return null;
    
    if (daysLeft < 0) {
      return <span className="badge badge-danger">⚠️ {Math.abs(daysLeft)} gün geçti!</span>;
    } else if (daysLeft <= 15) {
      return <span className="badge badge-warning">⏰ {daysLeft} gün kaldı</span>;
    }
    return <span className="badge badge-success">✅ {daysLeft} gün</span>;
  };

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="page-container">
      <Navbar />

      <div className="page-content">
        {/* Tab Navigation */}
        <div className="employee-tabs">
          <button 
            className={activeTab === 'list' ? 'active' : ''} 
            onClick={() => {
              setActiveTab('list');
              setSelectedVehicle(null);
            }}
          >
             Araç Listesi
          </button>
          <button 
            className={activeTab === 'warnings' ? 'active' : ''} 
            onClick={() => setActiveTab('warnings')}
          >
             Uyarılar {warnings?.total_warnings > 0 && (
              <span className="badge badge-danger" style={{marginLeft: '5px'}}>
                {warnings.total_warnings}
              </span>
            )}
          </button>
          {selectedVehicle && (
            <button 
              className={activeTab === 'maintenances' ? 'active' : ''} 
              onClick={() => setActiveTab('maintenances')}
            >
              🔧 {selectedVehicle.plate} - Bakımlar
            </button>
          )}
        </div>

        {/* Araç Listesi */}
        {activeTab === 'list' && (
          <>
            <div className="page-header">
              <h2>Araçlar ({totalCount})</h2>
              <div className="header-actions">
                <button className="btn-export" onClick={handleExportVehicles}>
                  📥 Excel'e Aktar
                </button>
                {selectMode ? (
                  <>
                    {selectedIds.length > 0 && hasPermission('delete_vehicles') && (
                      <button onClick={handleBulkDelete}
                       style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                          Seçilenleri Sil ({selectedIds.length})
                        </button>
                    )}
                    <button onClick={() => { setSelectMode(false); setSelectedIds([]); }}
                      style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                        İptal
                      </button>
                  </>
                ) : (
                  hasPermission('delete_vehicles') && (
                    <button onClick={() => setSelectMode(true)}
                      style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <rect x="3" y="3" width="18" height="18" rx="3"/>
                          <path d="M7 12l4 4 6-7"/>
                        </svg>
                        Seç
                      </button>
                  )
                )}
                {hasPermission('create_vehicles') && (
                  <button className="btn-primary" onClick={() => handleOpenModal()}>
                    + Yeni Araç
                  </button>
                )}
              </div>
            </div>

            <div className="filters">
              <input
                type="text"
                placeholder="Plaka, marka veya model ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    {selectMode && (
                      <th style={{width: '40px'}}>
                        <input type="checkbox"
                          onChange={(e) => { if (e.target.checked) setSelectedIds(vehicles.map(v => v.id)); else setSelectedIds([]); }}
                          checked={selectedIds.length === vehicles.length && vehicles.length > 0} />
                      </th>
                    )}
                    <th>Plaka</th>
                    <th>Araç</th>
                    <th>Yıl</th>
                    <th>KM</th>
                    <th>Sigorta</th>
                    <th>Kasko</th>
                    <th>Muayene</th>
                    <th>Durum</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicles.map(vehicle => (
                    <tr key={vehicle.id}>
                      {selectMode && (
                        <td>
                          <input type="checkbox"
                            checked={selectedIds.includes(vehicle.id)}
                            onChange={(e) => {
                              if (e.target.checked) setSelectedIds(prev => [...prev, vehicle.id]);
                              else setSelectedIds(prev => prev.filter(id => id !== vehicle.id));
                            }} />
                        </td>
                      )}
                      <td title={`#${vehicle.id}`}><strong>{vehicle.plate}</strong></td>
                      <td>{vehicle.brand} {vehicle.model}</td>
                      <td>{vehicle.year}</td>
                      <td>{vehicle.current_km?.toLocaleString() || '-'} km</td>
                      <td>{getWarningBadge(vehicle.insurance_days_left)}</td>
                      <td>{getWarningBadge(vehicle.kasko_days_left)}</td>
                      <td>{getWarningBadge(vehicle.inspection_days_left)}</td>
                      <td>
                        <span className={`badge ${vehicle.is_active ? 'badge-success' : 'badge-secondary'}`}>
                          {vehicle.is_active ? 'Aktif' : 'Pasif'}
                        </span>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button className="btn-view" onClick={() => handleViewMaintenances(vehicle)} title="Bakımlar">🔧</button>
                          {hasPermission('edit_vehicles') && (
                            <button className="btn-edit" onClick={() => handleOpenModal(vehicle)} title="Düzenle">✎</button>
                          )}
                          {hasPermission('delete_vehicles') && (
                            <button className="btn-delete" onClick={() => handleDeleteClick(vehicle)} title="Sil">
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <polyline points="3 6 5 6 21 6"/>
                                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                <path d="M10 11v6M14 11v6"/>
                                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                              </svg>
                          </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {totalCount > 0 && (
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'20px', flexWrap:'wrap'}}>
              <select value={pageSize} onChange={(e) => { const s = Number(e.target.value); setPageSize(s); localStorage.setItem('vehiclePageSize', s); fetchData(1, s); }}
                style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'14px', background:'white'}}>
                <option value={50}>50 kayıt</option><option value={100}>100 kayıt</option><option value={250}>250 kayıt</option>
              </select>
              <button onClick={() => fetchData(1)} disabled={currentPage===1} style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>«</button>
              <button onClick={() => fetchData(currentPage-1)} disabled={currentPage===1} style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===1?'not-allowed':'pointer', background:currentPage===1?'#f5f5f5':'white'}}>‹</button>
              {totalPages > 1 && Array.from({length: totalPages}, (_, i) => i+1).filter(p => p===1 || p===totalPages || Math.abs(p-currentPage)<=2).reduce((acc, p, i, arr) => { if (i > 0 && p - arr[i-1] > 1) acc.push('...'); acc.push(p); return acc; }, []).map((p, i) => p==='...' ? <span key={`dots-${i}`} style={{padding:'8px 4px'}}>...</span> : <button key={p} onClick={() => fetchData(p)} style={{padding:'8px 14px', borderRadius:'6px', border:`1px solid ${currentPage===p?'#667eea':'#ddd'}`, background:currentPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white', color:currentPage===p?'white':'#333', cursor:'pointer', fontWeight:currentPage===p?'600':'normal'}}>{p}</button>)}
              <button onClick={() => fetchData(currentPage+1)} disabled={currentPage===totalPages} style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>›</button>
              <button onClick={() => fetchData(totalPages)} disabled={currentPage===totalPages} style={{padding:'8px 12px', borderRadius:'6px', border:'1px solid #ddd', cursor:currentPage===totalPages?'not-allowed':'pointer', background:currentPage===totalPages?'#f5f5f5':'white'}}>»</button>
              <span style={{color:'#666', fontSize:'14px', marginLeft:'8px'}}>{((currentPage-1)*pageSize)+1}-{Math.min(currentPage*pageSize, totalCount)} / {totalCount} araç | Sayfa {currentPage} / {totalPages}</span>
            </div>
            )}
          </>
        )}

        {/* Uyarılar Sekmesi */}
        {activeTab === 'warnings' && warnings && (
          <>
            <div className="page-header">
              <h2>⚠️ Yaklaşan ve Geciken İşlemler</h2>
            </div>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px'}}>
              {/* Sigorta Uyarıları */}
              <div className="warning-card" style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{color: '#e53935', marginBottom: '15px'}}>
                  🛡️ Sigorta ({warnings.warnings.insurance?.length || 0})
                </h3>
                {warnings.warnings.insurance?.length === 0 ? (
                  <p style={{color: '#666'}}>Yaklaşan sigorta yok</p>
                ) : (
                  warnings.warnings.insurance?.map((w, i) => (
                    <div key={i} style={{
                      padding: '10px',
                      marginBottom: '10px',
                      background: w.is_expired ? '#ffebee' : '#fff3e0',
                      borderRadius: '8px',
                      borderLeft: `4px solid ${w.is_expired ? '#e53935' : '#ff9800'}`
                    }}>
                      <strong>{w.plate}</strong> - {w.brand} {w.model}
                      <br />
                      <small>
                        Bitiş: {formatDate(w.end_date)} | 
                        {w.is_expired 
                          ? <span style={{color: '#e53935'}}> {Math.abs(w.days_left)} gün geçti!</span>
                          : <span style={{color: '#ff9800'}}> {w.days_left} gün kaldı</span>
                        }
                      </small>
                    </div>
                  ))
                )}
              </div>

              {/* Kasko Uyarıları */}
              <div className="warning-card" style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{color: '#1976d2', marginBottom: '15px'}}>
                  🚙 Kasko ({warnings.warnings.kasko?.length || 0})
                </h3>
                {warnings.warnings.kasko?.length === 0 ? (
                  <p style={{color: '#666'}}>Yaklaşan kasko yok</p>
                ) : (
                  warnings.warnings.kasko?.map((w, i) => (
                    <div key={i} style={{
                      padding: '10px',
                      marginBottom: '10px',
                      background: w.is_expired ? '#ffebee' : '#e3f2fd',
                      borderRadius: '8px',
                      borderLeft: `4px solid ${w.is_expired ? '#e53935' : '#1976d2'}`
                    }}>
                      <strong>{w.plate}</strong> - {w.brand} {w.model}
                      <br />
                      <small>
                        Bitiş: {w.end_date} | 
                        {w.is_expired 
                          ? <span style={{color: '#e53935'}}> {Math.abs(w.days_left)} gün geçti!</span>
                          : <span style={{color: '#1976d2'}}> {w.days_left} gün kaldı</span>
                        }
                      </small>
                    </div>
                  ))
                )}
              </div>

              {/* Muayene Uyarıları */}
              <div className="warning-card" style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{color: '#7b1fa2', marginBottom: '15px'}}>
                  📋 Muayene ({warnings.warnings.inspection?.length || 0})
                </h3>
                {warnings.warnings.inspection?.length === 0 ? (
                  <p style={{color: '#666'}}>Yaklaşan muayene yok</p>
                ) : (
                  warnings.warnings.inspection?.map((w, i) => (
                    <div key={i} style={{
                      padding: '10px',
                      marginBottom: '10px',
                      background: w.is_expired ? '#ffebee' : '#f3e5f5',
                      borderRadius: '8px',
                      borderLeft: `4px solid ${w.is_expired ? '#e53935' : '#7b1fa2'}`
                    }}>
                      <strong>{w.plate}</strong> - {w.brand} {w.model}
                      <br />
                      <small>
                        Bitiş: {w.end_date} | 
                        {w.is_expired 
                          ? <span style={{color: '#e53935'}}> {Math.abs(w.days_left)} gün geçti!</span>
                          : <span style={{color: '#7b1fa2'}}> {w.days_left} gün kaldı</span>
                        }
                      </small>
                    </div>
                  ))
                )}
              </div>

              {/* Bakım Uyarıları */}
              <div className="warning-card" style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <h3 style={{color: '#388e3c', marginBottom: '15px'}}>
                  🔧 Bakım ({warnings.warnings.maintenance?.length || 0})
                </h3>
                {warnings.warnings.maintenance?.length === 0 ? (
                  <p style={{color: '#666'}}>Yaklaşan bakım yok</p>
                ) : (
                  warnings.warnings.maintenance?.map((w, i) => (
                    <div key={i} style={{
                      padding: '10px',
                      marginBottom: '10px',
                      background: w.is_expired ? '#ffebee' : '#e8f5e9',
                      borderRadius: '8px',
                      borderLeft: `4px solid ${w.is_expired ? '#e53935' : '#388e3c'}`
                    }}>
                      <strong>{w.plate}</strong> - {w.brand} {w.model}
                      <br />
                      <small>
                        {getMaintenanceTypeLabel(w.maintenance_type)} | 
                        Tarih: {formatDate(w.next_date)}
                        {w.next_km && ` | ${w.next_km?.toLocaleString()} km`}
                        <br />
                        {w.is_expired 
                          ? <span style={{color: '#e53935'}}>{Math.abs(w.days_left)} gün geçti!</span>
                          : <span style={{color: '#388e3c'}}>{w.days_left} gün kaldı</span>
                        }
                      </small>
                    </div>
                  ))
                )}
              </div>
            </div>
          </>
        )}

        {/* Bakım Kayıtları */}
        {activeTab === 'maintenances' && selectedVehicle && (
          <>
            <div className="page-header">
              <h2>🔧 {selectedVehicle.plate} - {selectedVehicle.brand} {selectedVehicle.model} Bakım Kayıtları</h2>
              <div className="header-actions">
                {hasPermission('edit_vehicles') && (
                 <button className="btn-primary" onClick={handleOpenMaintenanceModal}>
                     + Yeni Bakım Ekle
                       </button>
                 )}
              </div>
            </div>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>Bakım Türü</th>
                    <th>KM</th>
                    <th>Sonraki Bakım</th>
                    <th>Maliyet</th>
                    <th>Yapılan İşlem</th>
                    <th>Servis</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicleMaintenances.length === 0 ? (
                    <tr>
                      <td colSpan="9" style={{textAlign: 'center', padding: '40px'}}>
                        Henüz bakım kaydı yok
                      </td>
                    </tr>
                  ) : (
                    vehicleMaintenances.map(m => (
                      <tr key={m.id}>
                        <td title={`#${m.id}`}>{formatDate(m.maintenance_date)}</td>
                        <td>
                          <span className="badge badge-info">
                            {getMaintenanceTypeLabel(m.maintenance_type)}
                          </span>
                        </td>
                        <td>{m.current_km?.toLocaleString() || '-'} km</td>
                        <td>
                          {m.next_maintenance_date && (
                            <div>{formatDate(m.next_maintenance_date)}</div>
                          )}
                          {m.next_maintenance_km && (
                            <small>{m.next_maintenance_km?.toLocaleString()} km</small>
                          )}
                          {!m.next_maintenance_date && !m.next_maintenance_km && '-'}
                        </td>
                        <td>{formatCurrency(m.cost)}</td>
                        <td>{m.description || '-'}</td>
                        <td>{m.performed_by || '-'}</td>
                        <td>
                          {hasPermission('edit_vehicles') && (
                           <button className="btn-delete" onClick={() => handleDeleteMaintenance(m.id)} title="Sil">
                                   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="3 6 5 6 21 6"/>
                                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                    <path d="M10 11v6M14 11v6"/>
                                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                  </svg>
                              </button>
                            )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      {/* Araç Ekleme/Düzenleme Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={editingVehicle ? 'Araç Düzenle' : 'Yeni Araç'}
        size="large"
      >
        <form onSubmit={handleSubmit}>
          <h3 style={{marginBottom: 15, color: '#666'}}> Araç Bilgileri</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Plaka *</label>
              <input
                type="text"
                value={formData.plate}
                onChange={(e) => setFormData({...formData, plate: e.target.value.toUpperCase()})}
                placeholder="34 ABC 123"
                required
                style={{textTransform: 'uppercase'}}
              />
            </div>
            <div className="form-group">
              <label>Yıl *</label>
              <input
                type="number"
                value={formData.year}
                onChange={(e) => setFormData({...formData, year: e.target.value})}
                min="1990"
                max={new Date().getFullYear() + 1}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Marka *</label>
              <input
                type="text"
                value={formData.brand}
                onChange={(e) => setFormData({...formData, brand: e.target.value})}
                placeholder="Ford, Renault, vb."
                required
              />
            </div>
            <div className="form-group">
              <label>Model *</label>
              <input
                type="text"
                value={formData.model}
                onChange={(e) => setFormData({...formData, model: e.target.value})}
                placeholder="Transit, Megane, vb."
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mevcut KM</label>
              <input
                type="number"
                value={formData.current_km}
                onChange={(e) => setFormData({...formData, current_km: e.target.value})}
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label style={{display: 'flex', alignItems: 'center', gap: '10px', marginTop: '25px'}}>
                <input
                  type="checkbox"
                  checked={formData.is_active}
                  onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                  style={{width: '18px', height: '18px'}}
                />
                <span>Aktif Araç</span>
              </label>
            </div>
          </div>

          <h3 style={{marginTop: 25, marginBottom: 15, color: '#666'}}> Sigorta Bilgileri</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Sigorta Başlangıç</label>
              <input
                type="date"
                value={formData.insurance_start}
                onChange={handleInsuranceStartChange}
              />
            </div>
            <div className="form-group">
              <label>Sigorta Bitiş</label>
              <input
                type="date"
                value={formData.insurance_end}
                onChange={(e) => setFormData({...formData, insurance_end: e.target.value})}
              />
              <small style={{color: '#666'}}>Başlangıç seçince +1 yıl otomatik eklenir</small>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Sigorta Şirketi</label>
              <input
                type="text"
                value={formData.insurance_company}
                onChange={(e) => setFormData({...formData, insurance_company: e.target.value})}
                placeholder=""
              />
            </div>
            <div className="form-group">
              <label>Poliçe No</label>
              <input
                type="text"
                value={formData.insurance_policy_no}
                onChange={(e) => setFormData({...formData, insurance_policy_no: e.target.value})}
              />
            </div>
          </div>

          <h3 style={{marginTop: 25, marginBottom: 15, color: '#666'}}> Kasko Bilgileri</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Kasko Başlangıç</label>
              <input
                type="date"
                value={formData.kasko_start}
                onChange={handleKaskoStartChange}
              />
            </div>
            <div className="form-group">
              <label>Kasko Bitiş</label>
              <input
                type="date"
                value={formData.kasko_end}
                onChange={(e) => setFormData({...formData, kasko_end: e.target.value})}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Kasko Şirketi</label>
              <input
                type="text"
                value={formData.kasko_company}
                onChange={(e) => setFormData({...formData, kasko_company: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Kasko Poliçe No</label>
              <input
                type="text"
                value={formData.kasko_policy_no}
                onChange={(e) => setFormData({...formData, kasko_policy_no: e.target.value})}
              />
            </div>
          </div>

          <h3 style={{marginTop: 25, marginBottom: 15, color: '#666'}}> Muayene Bilgileri</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Muayene Başlangıç</label>
              <input
                type="date"
                value={formData.inspection_start}
                onChange={handleInspectionStartChange}
              />
            </div>
            <div className="form-group">
              <label>Muayene Bitiş</label>
              <input
                type="date"
                value={formData.inspection_end}
                onChange={(e) => setFormData({...formData, inspection_end: e.target.value})}
              />
            </div>
          </div>

          <div className="form-group" style={{marginTop: '15px'}}>
            <label>Notlar</label>
            <textarea
              value={formData.notes}
              onChange={(e) => setFormData({...formData, notes: e.target.value})}
              rows="2"
              placeholder="Araç hakkında notlar..."
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
              İptal
            </button>
            <button type="submit" className="btn btn-primary">
              {editingVehicle ? 'Güncelle' : 'Ekle'}
            </button>
          </div>
        </form>
      </Modal>

      {/* Bakım Ekleme Modal */}
      <Modal
        isOpen={isMaintenanceModalOpen}
        onClose={() => setIsMaintenanceModalOpen(false)}
        title={`${selectedVehicle?.plate} - Yeni Bakım Kaydı`}
        size="medium"
      >
        <form onSubmit={handleSubmitMaintenance}>
          <div className="form-row">
            <div className="form-group">
              <label>Bakım Tarihi *</label>
              <input
                type="date"
                value={maintenanceForm.maintenance_date}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, maintenance_date: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Bakım Türü *</label>
              <select
                value={maintenanceForm.maintenance_type}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, maintenance_type: e.target.value})}
                required
              >
                {maintenanceTypes.map(t => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mevcut KM</label>
              <input
                type="number"
                value={maintenanceForm.current_km}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, current_km: e.target.value})}
                placeholder={selectedVehicle?.current_km || '0'}
              />
            </div>
            <div className="form-group">
              <label>Maliyet (₺)</label>
              <input
                type="number"
                step="0.01"
                value={maintenanceForm.cost}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, cost: e.target.value})}
                placeholder="0.00"
              />
            </div>
          </div>

          <h4 style={{marginTop: '20px', marginBottom: '10px', color: '#666'}}>Sonraki Bakım</h4>

          <div className="form-row">
            <div className="form-group">
              <label>Sonraki Bakım Tarihi</label>
              <input
                type="date"
                value={maintenanceForm.next_maintenance_date}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, next_maintenance_date: e.target.value})}
              />
            </div>
            <div className="form-group">
              <label>Sonraki Bakım KM</label>
              <input
                type="number"
                value={maintenanceForm.next_maintenance_km}
                onChange={(e) => setMaintenanceForm({...maintenanceForm, next_maintenance_km: e.target.value})}
                placeholder="Örn: 50000"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Yapılan İşlemler</label>
            <textarea
              value={maintenanceForm.description}
              onChange={(e) => setMaintenanceForm({...maintenanceForm, description: e.target.value})}
              rows="3"
              placeholder="Yağ değişimi, filtre değişimi, vb."
            />
          </div>

          <div className="form-group">
            <label>Servis / Usta</label>
            <input
              type="text"
              value={maintenanceForm.performed_by}
              onChange={(e) => setMaintenanceForm({...maintenanceForm, performed_by: e.target.value})}
              placeholder="Servis adı veya usta"
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={() => setIsMaintenanceModalOpen(false)}>
              İptal
            </button>
            <button type="submit" className="btn btn-primary">
              Kaydet
            </button>
          </div>
        </form>
      </Modal>

      {/* Onay Modalı */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        confirmText={confirmModal.confirmText}
        loading={confirmModal.loading}
      />
    </div>
  );
}

export default Vehicles;